import { render } from "./SeatDemo.vue?vue&type=template&id=73354093"
import script from "./SeatDemo.vue?vue&type=script&lang=js"
export * from "./SeatDemo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/amee/iptu-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__